import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const FloatScanButton = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<>
			<Stack
				sx={{
					position: 'fixed',
					bottom: '16px',
					left: '50%',
					transform: 'translate(-50%, 0%)',
				}}
			>
				<Button
					disableRipple
					size="large"
					variant="contained"
					startIcon={<PhotoCameraIcon />}
					onClick={() => {
						navigate(-1);
					}}
				>
					{t('home.scan')}
				</Button>
			</Stack>
		</>
	);
};

export default FloatScanButton;
